import React from 'react';
import { IconProps } from '../types';
const MinecraftSalmon: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="11" y="1" width="1" height="1" fill="rgba(88, 64, 60, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(88, 64, 60, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(88, 64, 60, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(189, 146, 139, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(88, 64, 60, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(88, 64, 60, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(189, 146, 139, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(189, 146, 139, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(153, 115, 109, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(61, 43, 41, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(88, 64, 60, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(88, 64, 60, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(102, 54, 29, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(102, 54, 29, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(171, 53, 51, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(144, 41, 40, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(153, 115, 109, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(61, 43, 41, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(61, 43, 41, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(88, 64, 60, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(189, 146, 139, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(153, 115, 109, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(102, 54, 29, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(144, 41, 40, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(171, 53, 51, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(190, 70, 68, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(114, 53, 48, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(61, 43, 41, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(88, 64, 60, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(153, 115, 109, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(171, 53, 51, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(171, 53, 51, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(171, 53, 51, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(190, 70, 68, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(171, 53, 51, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(27, 42, 38, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(102, 54, 29, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(171, 53, 51, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(171, 53, 51, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(171, 53, 51, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(190, 70, 68, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(171, 53, 51, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(144, 41, 40, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(27, 42, 38, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(62, 78, 67, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(93, 119, 100, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(93, 119, 100, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(144, 41, 40, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(190, 70, 68, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(171, 53, 51, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(144, 41, 40, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(114, 53, 48, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(27, 42, 38, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(62, 78, 67, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(62, 78, 67, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(93, 119, 100, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(101, 148, 115, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(144, 41, 40, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(171, 53, 51, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(114, 53, 48, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(27, 42, 38, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(62, 78, 67, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(93, 119, 100, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(93, 119, 100, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(62, 78, 67, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(93, 119, 100, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(93, 119, 100, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(114, 53, 48, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(114, 53, 48, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(27, 42, 38, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(62, 78, 67, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(23, 23, 23, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(76, 96, 81, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(76, 96, 81, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(93, 119, 100, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(62, 78, 67, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(114, 53, 48, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(27, 42, 38, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(62, 78, 67, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(76, 96, 81, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(88, 64, 60, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(62, 78, 67, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(62, 78, 67, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(27, 42, 38, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(62, 78, 67, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(153, 115, 109, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(88, 64, 60, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(27, 42, 38, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(153, 115, 109, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(153, 115, 109, 255)" />
</svg>);
export default MinecraftSalmon;